<template>
  <div
    class="nx-list-page dispatch-center-page"
    :class="{ 'is-components': isComponents }"
  >
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template #menu="{ size, row, index }">
        <el-button type="text" :size="size" @click="onRowView(row, index)">
          详情
        </el-button>
        <el-button
          v-if="showDispatchComplete(row)"
          class="menu-btn-finish"
          type="text"
          :size="size"
          @click="openLocationDialog(row)"
        >
          完成
        </el-button>
      </template>
    </avue-crud>

    <!-- 选择煤流线弹窗 -->

      <dialog-reset
        :visible.sync="coalLineDialogVisible"
        top="15vh"
        :zoomShow="false"
        height="200px"
        width="650px"
        title="选择煤流线"
        :appendToBody="false"
        :modalShow="false"
      >
      <el-form label-width="100px">
        <el-form-item label="煤流线">
          <el-select v-model="selectedCoalLine" placeholder="请选择煤流线" style="width: 100%">
            <el-option
              v-for="item in coalLineOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="dialog_footer">
        <el-button @click="closeCoalLineDialog">取消</el-button>
        <el-button type="primary" @click="confirmCoalLineSelection" :disabled="!selectedCoalLine">确定</el-button>
      </div>
      </dialog-reset>

    <!-- 选择库位弹窗 -->
    <el-dialog
      title="选择库位"
      :visible.sync="locationDialogVisible"
      width="800px"
      destroy-on-close
      :modal="false"
    >
      <div class="location-dialog">
        <div class="dialog-left">
          <div class="section-title">选择仓库</div>
          <el-input
            v-model="storeSearchKeyword"
            placeholder="Q 搜索仓库"
            prefix-icon="el-icon-search"
            class="search-input"
            @input="filterStores"
          />
          <div class="store-list">
            <div
              v-for="store in filteredStores"
              :key="store.storeNo"
              :class="['store-item', { active: selectedStore && selectedStore.storeNo === store.storeNo }]"
              @click="selectStore(store)"
            >
              <div class="store-name">{{ store.storeName }}</div>
              <div class="store-code">仓库编号: {{ store.storeNo }}</div>
            </div>
          </div>
        </div>

        <div class="dialog-right">
          <div class="section-title">选择库位</div>
          <div class="current-store" v-if="selectedStore">
            当前仓库: {{ selectedStore.storeName }} ({{ selectedStore.storeNo }})
            <span class="selected-count">已选择{{ selectedLocations.length }}个库位</span>
          </div>
          <div class="location-grid" v-if="selectedStore">
            <div
              v-for="location in locationList"
              :key="location.locationCode"
              :class="['location-item', {
                selected: selectedLocations.some(loc => loc.locationCode === location.locationCode),
                disabled: location.status === '占用' || location.status === '维护中'
              }]"
              @click="toggleLocation(location)"
            >
              <div class="location-code">{{ location.locationCode }}</div>
              <div class="location-status">{{ location.locationName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="selected-info">已选择{{ selectedLocations.length }}个库位</div>
        <div class="footer-buttons">
          <el-button @click="closeLocationDialog">取消</el-button>
          <el-button type="primary" @click="confirmLocationSelection" :disabled="selectedLocations.length === 0">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail, confirm, getStoreList, getLocationList } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  props: {
    planNo: {
      type: String,
      default: ""
    },
    //作为组件使用时隐藏查询及操作区域
    isComponents: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      defaultParams: {
        planNo: this.planNo,
      },
      apiConfig: { getList, getDetail },
      infoCardData: [], // 卡片数据
      // 煤流线选择弹窗相关数据
      coalLineDialogVisible: false,
      selectedCoalLine: '',
      coalLineOptions: [
        { label: '煤流线1', value: '煤流线1' },
        { label: '煤流线2', value: '煤流线2' },
        { label: '煤流线3', value: '煤流线3' },
        { label: '煤流线4', value: '煤流线4' },
        { label: '煤流线5', value: '煤流线5' }
      ],
      // 库位选择弹窗相关数据
      locationDialogVisible: false,
      currentTaskId: null,
      currentRow: null,
      storeList: [],
      filteredStores: [],
      storeSearchKeyword: '',
      selectedStore: null,
      locationList: [],
      selectedLocations: [],
      option: {
        ...this.$store.state.publicOption,
        menu: !this.isComponents,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        // 自定义 #menu 整列替换内置菜单，详情在模板内显式写出，与「完成」共用 :size="size"
        viewBtn: false,
        column: [
          {
            label: '计划编号',
            prop: 'planNo',
            search: true, // 查询是否显示
            minWidth: 180, // 表格最小宽度
            maxlength: 200,
            // type: 'select',
            // remote: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?planNo={{key}}',
            // props: {
            //   label: 'planNo',
            //   value: 'planNo'
            // },
          },
          {
            label: '计划名称',
            prop: 'planName',
            search: true, // 查询是否显示
            minWidth: 180, // 表格最小宽度
            maxlength: 200,
            // type: 'select',
            // remote: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?planName={{key}}',
            // props: {
            //   label: 'planName',
            //   value: 'planName'
            // },
          },
          {
            label: '车号',
            prop: 'trainNumber',
            search: true, // 查询是否显示
            minWidth: 180, // 表格最小宽度
            maxlength: 200,
            formatter: (row, value) => {
              if (value !== undefined && value !== null && value !== '') return value
              const t = row.type
              const oid = row.outInStockId
              const noVehicle = oid == null || oid === '' || Number(oid) <= 0
              if ((t == 2 || t == 3) && noVehicle && (row.step === 101 || row.step === 102)) return '—（计划级）'
              return ''
            },
          },
          {
            label: '流程名称',
            prop: 'stepName',
            minWidth: 180, // 表格最小宽度
            maxlength: 200,
          },
          {
            label: '业务类型',
            prop: 'type',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dicData: this.$store.getters.commonDict['businessType'],
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '计划状态',
            prop: 'status',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=planState",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            formatter: (row, value, label) => {
              if (row && row.status == 3) return '撤回'
              return label || value
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 0
          },
          {
            label: '班次编码',
            prop: 'teamNo',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?teamNo={{key}}',
            props: {
              label: 'teamNo',
              value: 'teamNo'
            },
          },
          {
            label: '班次名称',
            prop: 'teamName',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            maxlength: 200,
            // type: 'select',
            // remote: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?teamName={{key}}',
            // props: {
            //   label: 'teamName',
            //   value: 'teamName'
            // },
          },
          {
            label: '开始时间',
            prop: 'taskStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
          },
          {
            label: '结束时间',
            prop: 'taskEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
          },
          {
            label: '操作人姓名',
            prop: 'optName',
            search: false, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            maxlength: 200,
            // type: 'select',
            // remote: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?optName={{key}}',
            // props: {
            //   label: 'optName',
            //   value: 'optName'
            // },
          },
          {
            label: '创建人姓名',
            prop: 'createName',
            search: false, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            maxlength: 200,
            // type: 'select',
            // remote: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?name={{key}}',
            // props: {
            //   label: 'createName',
            //   value: 'createName'
            // },
          },
          {
            label: '备注',
            prop: 'remark',
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  mounted () {

  },
  methods: {
    onRowView (row, index) {
      this.$refs.crud && this.$refs.crud.rowView(row, index);
    },
    /** 汽运入(3)/出(2) 且计划级工单：无有效 out_in_stock_id（null/空/≤0），step 101/102 */
    isTruckPlanLevelRow (row) {
      const t = row.type
      if (t != 2 && t != 3) return false
      const oid = row.outInStockId
      if (oid != null && oid !== '' && oid !== undefined && Number(oid) > 0) return false
      const s = row.step
      return s === 101 || s === 102
    },
    /** 煤流线确认：铁运 step3 + mlx；汽运计划级 step102 + mlx（与铁运同班组码） */
    isCoalLineConfirmTask (row) {
      if (row.teamNo === 'mlx') return true
      if (row.stepName === '煤流线确认') return true
      const t = row.type
      if (t == 1 && row.step === 3) return true
      if ((t == 2 || t == 3) && row.step === 102) return true
      return false
    },
    /** 仓库货位确认：铁运 step2 + ckgl；汽运计划级 step101 + ckgl */
    isWarehouseConfirmTask (row) {
      if (row.teamNo === 'ckgl') return true
      if (row.stepName === '仓库货位确认') return true
      const t = row.type
      if (t == 1 && row.step === 2) return true
      if ((t == 2 || t == 3) && row.step === 101) return true
      return false
    },
    /** 展示「完成」：进行中且非翻车机人工等待环节 */
    showDispatchComplete (row) {
      if (row.status != 1) return false
      if (row.stepName === '翻车机作业') return false
      if (row.type == 1 && row.step === 4) return false
      return true
    },

    // 打开库位 / 煤流线 / 简单关单
    openLocationDialog (row) {
      this.currentTaskId = row.id
      this.currentRow = row
      this.planNo = row.planNo
      if (this.isCoalLineConfirmTask(row)) {
        this.selectedCoalLine = ''
        this.coalLineDialogVisible = true
        return
      }
      if (this.isWarehouseConfirmTask(row)) {
        this.locationDialogVisible = true
        this.loadStoreList()
        return
      }
      this.$confirm('确认完成该调度工单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        confirm(row.id).then(res => {
          if (res.data.code == 200) {
            this.$message.success('确认成功')
            this.onLoad(this.page, this.query)
          }
        }).catch(err => {
          this.$message.error((err && err.message) || '确认失败')
        })
      }).catch(() => {})
    },

    // 关闭煤流线选择弹窗
    closeCoalLineDialog () {
      this.coalLineDialogVisible = false
      this.selectedCoalLine = ''
      this.currentTaskId = null
    },

    // 确认煤流线选择（铁运入库 / 汽运计划级煤流线，ext 写入计划或车辆库存扩展，与仓库 JSON 结构区分）
    confirmCoalLineSelection () {
      if (!this.selectedCoalLine) {
        this.$message.warning('请选择煤流线')
        return
      }
      const extData = JSON.stringify([{ flowLine: this.selectedCoalLine }])
      confirm(this.currentTaskId, extData).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "确认成功!"
          })
          this.closeCoalLineDialog()
          this.onLoad(this.page, this.query)
        }
      }).catch(err => {
        this.$message.error('确认失败')
        console.error(err)
      })
    },

    // 关闭库位选择弹窗
    closeLocationDialog () {
      this.locationDialogVisible = false
      this.resetDialogData()
    },

    // 重置弹窗数据
    resetDialogData () {
      this.currentTaskId = null
      this.storeList = []
      this.filteredStores = []
      this.storeSearchKeyword = ''
      this.selectedStore = null
      this.locationList = []
      this.selectedLocations = []
    },

    // 加载仓库列表
    loadStoreList () {
      const planNo = this.currentRow.planNo;
      getStoreList(planNo).then(res => {
        if (res.data.code === 200) {
          this.storeList = res.data.data || []
          this.filteredStores = [...this.storeList]
        }
      }).catch(err => {
        this.$message.error('获取仓库列表失败')
        console.error(err)
      })
    },

    // 过滤仓库列表
    filterStores () {
      if (!this.storeSearchKeyword) {
        this.filteredStores = [...this.storeList]
      } else {
        this.filteredStores = this.storeList.filter(store =>
          store.storeName.includes(this.storeSearchKeyword) ||
          store.storeNo.includes(this.storeSearchKeyword)
        )
      }
    },

    // 选择仓库
    selectStore (store) {
      this.selectedStore = store
      this.selectedLocations = []
      const planNo = this.currentRow.planNo;
      this.loadLocationList(store.storeNo, planNo)
    },

    // 加载库位列表
    loadLocationList (storeNo, planNo) {
      getLocationList(storeNo,planNo).then(res => {
        if (res.data.code === 200) {
          this.locationList = res.data.data || []
        }
      }).catch(err => {
        this.$message.error('获取库位列表失败')
        console.error(err)
      })
    },

    // 切换库位选择状态
    toggleLocation (location) {
      if (location.status === '占用' || location.status === '维护中') {
        return
      }

      const index = this.selectedLocations.findIndex(loc => loc.locationCode === location.locationCode)
      if (index > -1) {
        this.selectedLocations.splice(index, 1)
      } else {
        this.selectedLocations.push(location)
      }
    },

    // 确认库位选择
    confirmLocationSelection () {
      if (this.selectedLocations.length === 0) {
        this.$message.warning('请至少选择一个库位')
        return
      }

      // 封装选中的仓库和库位信息
      const selectionData = this.selectedLocations.map(ii=>{
        return {
          locationCode:ii.locationCode,
          locationName:ii.locationName,
          storeName:this.selectedStore.storeName,
          storeNo:this.selectedStore.storeNo
        }
      })

      // 转换为JSON字符串
      const extData = JSON.stringify(selectionData)

      // 调用完成接口，传递ext字段
      confirm(this.currentTaskId, extData).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "确认成功!"
          })
          this.closeLocationDialog()
          this.onLoad(this.page, this.query)
        }
      }).catch(err => {
        this.$message.error('确认失败')
        console.error(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dispatch-center-page {
  .menu-btn-finish.el-button--text {
    color: #16a34a;
    &:hover {
      color: #15803d;
    }
  }
}

// 作为组件使用时隐藏查询及操作区域
.is-components {
  ::v-deep .avue-crud__search {
    display: none !important;
  }
  ::v-deep .avue-crud__menu {
    display: none !important;
  }
}

// 库位选择弹窗样式
.location-dialog {
  display: flex;
  height: 500px;

  .dialog-left {
    width: 300px;
    border-right: 1px solid #e6e6e6;
    padding-right: 20px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }

    .search-input {
      margin-bottom: 15px;
    }

    .store-list {
      max-height: 400px;
      overflow-y: auto;

      .store-item {
        padding: 12px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        margin-bottom: 8px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          background-color: #f0f9ff;
        }

        &.active {
          border-color: #409eff;
          background-color: #e6f7ff;
        }

        .store-name {
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-bottom: 4px;
        }

        .store-code {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }

  .dialog-right {
    flex: 1;
    padding-left: 20px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }

    .current-store {
      margin-bottom: 15px;
      padding: 10px;
      background-color: #f5f5f5;
      border-radius: 4px;
      font-size: 14px;

      .selected-count {
        float: right;
        color: #409eff;
        font-weight: bold;
      }
    }

    .location-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      max-height: 350px;
      overflow-y: auto;

      .location-item {
        padding: 15px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;

        &:hover:not(.disabled) {
          border-color: #409eff;
          background-color: #f0f9ff;
        }

        &.selected {
          border-color: #409eff;
          background-color: #e6f7ff;
        }

        &.disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
          opacity: 0.6;
        }

        .location-code {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 5px;
        }

        .location-status {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .selected-info {
    color: #409eff;
    font-weight: bold;
    padding-left: 20px;
  }

  .footer-buttons {
    .el-button {
      margin-left: 10px;
    }
  }
}
</style>
